import { render, staticRenderFns } from "./sysTransLogs.vue?vue&type=template&id=13dab258"
import script from "./sysTransLogs.vue?vue&type=script&lang=js"
export * from "./sysTransLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\pinmingproject\\suppervision-manager-ui-huangshi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13dab258')) {
      api.createRecord('13dab258', component.options)
    } else {
      api.reload('13dab258', component.options)
    }
    module.hot.accept("./sysTransLogs.vue?vue&type=template&id=13dab258", function () {
      api.rerender('13dab258', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/logs/sysTransLogs.vue"
export default component.exports